module.exports = __webpack_public_path__ + "static/defnder-90-td5-country-station-wagon-interior-ef2d0918b6d5d6dfb453870111c6650b.jpg";